export const getLogoutDestPage = (akamaiDomain, activeLocale) => `${akamaiDomain}/${activeLocale.toLowerCase()}/travel/my-bookings/summary`;

export const isLinkContent = (locale) => {
  const markets = ['de-de', 'en-hk', 'en-sg', 'it-it', 'fr-fr', 'es-es', 'nl-nl', 'sv-se'];
  return markets.indexOf(locale?.toLowerCase()) !== -1;
};

export const generateModuleConfig = (locale, langPack) => ({
  urls: {
    summaryOverview: locale && `/${locale.toLowerCase()}/travel/my-bookings/summary`,
    tripOverview: locale && `/${locale.toLowerCase()}/travel/my-bookings/trip-overview`,
    changeHotelDates: locale && `/${locale.toLowerCase()}/travel/my-bookings/change-hotel-dates`,
    carCancellations: locale && `/${locale.toLowerCase()}/travel/my-bookings/car-cancellation`,
    hotelCancellations: locale && `/${locale.toLowerCase()}/travel/my-bookings/hotel-cancellation`,
    flightCancellations: locale && `/${locale.toLowerCase()}/travel/my-bookings/air-cancellation`,
  },
  intLinks: {
    summaryIphoneIntlink: langPack?.summaryIphoneIntlink,
    overviewIphoneIntlink: langPack?.overviewIphoneIntlink,
    summaryAndroidIntlink: langPack?.summaryAndroidIntlink,
    overviewAndroidIntlink: langPack?.overviewAndroidIntlink,
  },
  locale,
  localisationValues: {},
});
